import { react2panel } from 'common/util/react2panel';
import { InsightsMetricChartReact } from './index';
export const InsightsMetricChartEl = react2panel("mp-insights-metric-chart", InsightsMetricChartReact, {
  contexts: ["segmentFilterController"]
});